import {options} from 'sw-toolbox';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ModalController } from 'ionic-angular';
import { ApiUserProvider } from '../../providers/api-user/api-user';

import { DatePipe } from '@angular/common';
import { Http, Headers, RequestOptions} from '@angular/http';
import { ReserveModalPage } from '../../pages/reserve-modal/reserve-modal';
import { EditModalPage } from '../../pages/edit-modal/edit-modal';

//import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
//import { map } from 'rxjs/operators';

import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { ImagePicker, ImagePickerOptions } from  '@ionic-native/image-picker';

import { File } from '@ionic-native/file/ngx';
import { Camera, CameraOptions } from '@ionic-native/camera';
//import { Camera, CameraOptions } from '@ionic-native/camera/ngx';

import { FileTransfer, FileTransferObject, FileUploadOptions } from '@ionic-native/file-transfer';
import { toBase64String } from '@angular/compiler/src/output/source_map';
import { Base64 } from '@ionic-native/base64/ngx';
//import { CameraMock } from '@ionic-native-mocks/camera';
/**
 * Generated class for the NursePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-nurse',
  templateUrl: 'nurse.html',
})

export class NursePage {
  ResNote:string="";
  DocSerial:string="";
  DocName:string="";
  TypeSerial:string="";
  TypeName:string="";
  HospitalSerial:string="";
  HospitalName:string="";
  SelectedDoc:any;
  DocList : Array<any>=[];
  JobList : Array<any>=[];
  TypeList : Array<any>=[];
  HospitalList : Array<any>=[];
  DateFrom: Date;// = new Date();//.toISOString();
  DateT: Date ;//= new Date();//.toISOString();
  //DateTo: Date= new Date(); //.toISOString();
  Visible:boolean=true;
  Visible1:boolean=true;
  AddView=false;
  constructor(public modalController:ModalController,public navCtrl: NavController, public navParams: NavParams,
    public apiUserProvider:ApiUserProvider,private http:Http,public alertCtrl: AlertController
    ,public loadingCtrl: LoadingController
   ,public datepipe: DatePipe,public imagePicker: ImagePicker,public file:File,
   private camera: Camera,private transfer: FileTransfer,private base64: Base64) {
    let loader = this.loadingCtrl.create({
      content: "Please wait...",
      //duration: 3000,
    });
    loader.present();
    this.http.get(this.apiUserProvider.MyDomain+'/api/Default/GetDoctors/'
    +this.apiUserProvider.ClinicID)
    .map(res => res.json()).subscribe(data => {         
         this.DocList = data;
      
         loader.dismiss();
    },err => {
      console.log(err);
      loader.dismiss();
      const alert = this.alertCtrl.create({
        title: 'Error message',
        subTitle: err,
        buttons: ['OK']
      });
      alert.present();
      });

      this.http.get(this.apiUserProvider.MyDomain+'/api/Default/GetTypes/'
    +this.apiUserProvider.ClinicID)
    .map(res => res.json()).subscribe(data2 => {         
         this.TypeList = data2;       
    },err => {
      console.log(err);
      loader.dismiss();
      const alert = this.alertCtrl.create({
        title: 'Error message',
        subTitle: err,
        buttons: ['OK']
      });
      alert.present();
      });

      this.http.get(this.apiUserProvider.MyDomain+'/api/Default/GetHospitals/'
      +this.apiUserProvider.ClinicID)
      .map(res => res.json()).subscribe(data3 => {         
           this.HospitalList = data3;       
      },err => {
        console.log(err);
        loader.dismiss();
        const alert = this.alertCtrl.create({
          title: 'Error message',
          subTitle: err,
          buttons: ['OK']
        });
        alert.present();
        });
  }
  

  chooseFile3() {
    let options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      sourceType: this.camera.PictureSourceType.CAMERA,
      allowEdit: true,
      encodingType: this.camera.EncodingType.JPEG,
      targetWidth: 500,
      targetHeight: 500,
      saveToPhotoAlbum: false,      
    };  
    this.imageLists=[];
    this.imageUploadLists=[];
    this.camera.getPicture(options).then((img) => {

       this.imageLists.push('data:image/jpeg;base64,' +  img);
       this.imageUploadLists.push(  img);
    }).catch((reason) => {
      console.log(reason);
    });
  }


  public imageLists: any[] = [];
  public imageUploadLists:any[]=[];  
  public loadMultipleImageFromGallery() {  
    let options = {  
        //here Quality of images, defaults to 100  
        quality: 100,  
        //here Width of an Image  
        width: 600,  
        //here Height of an Image  
        height: 600,  
        /** Output type, defaults to 0 (FILE_URI). 
 
        * FILE_URI :0 (number) it returns a actual path for an image 
 
        */  
        DATA_URI: 1,
        //(number) it returns a this.base64 data  for an image  
        outputType: 1  ,
        //here Maximum image count for selection, defaults to 15.  
        maximumImagesCount: 1//(1 - 15) numbers  
        //while setting a number 15 we can load 15 images in one selection.  
    };  
    this.imageLists=[];
    this.imageUploadLists=[];
    this.imagePicker.getPictures(options).then((results) => {  
        for (let index = 0; index < results.length; index++) {  
            //here iam converting image data to base64 data and push a data to array value.  
            this.imageLists.push('data:image/jpeg;base64,' + results[index]); 
            this.imageUploadLists.push( results[index]); 
            //this.MyImage= 'data:image/jpeg;base64,' + results[index];
            //this.image='data:image/jpeg;base64,' + results[index];
            //this.fileToUpload=results[index];
        }  
        console.log('Image Lists', this.imageLists);  
    }, (error) => {  
        // Handle error   
        console.log('Error occurredwhile loading', error);  
    });  
} 
  //imageC: any;
  //cameraMock:CameraMock;
  ViewAdd()
  {
    this.AddView=true;
  }



  imageResponse: any;
  //image: any;
  MyImage:any;
  fileToUpload :any='';
  
  public openModal(item1:any){
    var item = { 'Serial' : item1.RSerial,'Note' : item1.RNote,'Date':item1.RDate,
  'FileName': this.apiUserProvider.MyDomain+'/Images/'+ item1.RFileName+".jpg" };
    var modalPage = this.modalController.create(ReserveModalPage,
      item);
    modalPage.present();
  //  modalPage.onDidDismiss(data => {
   //   item1.eval=data.rate;
   //   item1.note=data.note;
     
  // });
}
  
  ionViewDidLoad() {
    console.log('ionViewDidLoad NursePage');
  }
  ViewR(Serialvalue: string,Namevalue: string): void {
    this.DocSerial = Serialvalue;
    this.DocName = Namevalue;
  }
  ViewT(Serialvalue: string,Namevalue: string): void {
    this.TypeSerial = Serialvalue;
    this.TypeName = Namevalue;
  }
  ViewH(Serialvalue: string,Namevalue: string): void {
    this.HospitalSerial = Serialvalue;
    this.HospitalName = Namevalue;
  }
  NewSet()
  {
    this.Visible1=true;
  }

  sendPostRequest() {
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    const requestOptions = new RequestOptions({ headers: headers });

    let postData = {
            "name": "Customer004",
            "email": "customer004@email.com",
            "tel": "0000252525"
    }

    this.http.post("http://127.0.0.1:3000/customers", postData, requestOptions)
      .subscribe(data => {
        console.log(data['_body']);
       }, error => {
        console.log(error);
      });
  }

  Add()
  {
    let loader = this.loadingCtrl.create({
      content: "Please wait...",
      //duration: 3000,
    });
    loader.present();
    let Df=this.datepipe.transform(this.DateFrom, 'yyyy-MM-dd');
    //var displaytime = this.DateT.toLocaleTimeString();
    let TH=this.DateT.toString().substr(0, this.DateT.toString().indexOf(':')); //.getHours();
    let TM=this.DateT.toString().substr( this.DateT.toString().indexOf(':')+1);
    this.http.get(this.apiUserProvider.MyDomain+'/api/Default/setReservations/'
    +this.apiUserProvider.ClinicID+'-'+this.DocSerial+'-'+this.apiUserProvider.USerial+'-'+Df+'-'+TH+'-'+TM
    +'-'+this.HospitalSerial+'-'+this.TypeSerial+'-'+this.ResNote+'-'+this.imageLists[0])
    .map(res => res.json()).subscribe(data => {         
         this.JobList = data;
         this.Visible1=false;
         this.AddView=false;
         if(this.JobList.length>0)
         if(this.imageLists.length>0 ) 
         this.doImageUpload(this.JobList[this.JobList.length-1].RFileName);

         
         loader.dismiss();

    },err => {
      alert(JSON.stringify(err));
      alert(err);
      alert(this.imageLists[0]);
      console.log(err);
      loader.dismiss();
      const alert1 = this.alertCtrl.create({
        title: 'Error message',
        subTitle: err,
        buttons: ['OK']
      });
      alert1.present();
      });
      //this.DateFrom=new Date();
      this.DateT=new Date();
      this.ResNote="";
      this.HospitalSerial="";
      this.TypeSerial="";
      //this.MyImage=undefined;
  }
  public CheckRequired():boolean
  {
    if(this.DateFrom===undefined || this.DocSerial==="" )
    {
        return false
    }
        return true;
  }
  View()
  {
    if(!this.CheckRequired())
    {
      const alert2 = this.alertCtrl.create({
        title: 'رسالة خطأ',
        subTitle: 'اكمل البيانات',
        buttons: ['OK']
      });
      alert2.present();
    }
    else
    {
    let loader = this.loadingCtrl.create({
      content: "Please wait...",
      //duration: 3000,
    });
    loader.present();
    let Df=this.datepipe.transform(this.DateFrom, 'yyyy-MM-dd');
    this.http.get(this.apiUserProvider.MyDomain+'/api/Default/GetReservations/'
    +this.apiUserProvider.ClinicID+'-'+this.DocSerial+'-'+Df)
    .map(res => res.json()).subscribe(data => {         
         this.JobList = data;
         this.Visible1=false;
         //if(this.JobList !== undefined && this.JobList.length>0)
       
         //this.Visible=true;
         //else
         //this.Visible=false;
         loader.dismiss();
    },err => {
      console.log(err);
      loader.dismiss();
      const alert = this.alertCtrl.create({
        title: 'Error message',
        subTitle: err,
        buttons: ['OK']
      });
      alert.present();
      });
  }
  }
  DeleteR(item1:any)
  {
    let prompt = this.alertCtrl.create({
      title: 'تأكيد الحذف',
      message:"هل تريد حذف بيانات الحجز",
      
      buttons: [
        {
          text: 'رجوع',
          handler: data => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'حذف',
          handler: data => {
         let loader = this.loadingCtrl.create({
          content: "انتظر قليلا...",
          //duration: 3000,
        });
        loader.present();

        var headers = new Headers();
    
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json' );
       
        const requestOptions = new RequestOptions({ headers: headers }); 
    
          let postParams = {
           // file:this.imageUploadLists[0],
           RSerial:item1['RSerial']
            
          }
          
          this.http.post( this.apiUserProvider.MyDomain+'/api/Default/DeleteMyData',JSON.stringify(postParams), requestOptions)
          .map(res => res.json()).subscribe(data => {
            console.log("received data =>" + JSON.stringify(data));
              this.JobList = data;
             this.Visible1=false;
             this.AddView=false;
             this.imageLists=[];
             this.imageUploadLists=[];
             this.DateT=new Date();
             this.ResNote="";
             this.HospitalSerial="";
             this.TypeSerial="";
             //if(this.JobList.length>0)
             //if(this.imageLists.length>0 ) 
             //this.doImageUpload(this.JobList[this.JobList.length-1].RFileName);
    
             loader.dismiss();
    
            },err => {
              alert(this.imageLists[0]);
              alert(this.imageUploadLists[0]);
              console.log(err);
              loader.dismiss();
              const alert2 = this.alertCtrl.create({
                title: 'Error message',
                subTitle: err,
                buttons: ['OK']
              });
              alert2.present();
              });

       // loader.dismiss();
       }
}
  ]});

  prompt.present();

  }
  public CheckRequired2():boolean
  {
    if(this.DateT===undefined || this.HospitalSerial==="" || this.TypeSerial==="")
    {
        return false
    }
        return true;
  }
PostMyData()
{
  if(!this.CheckRequired2())
    {
      const alert2 = this.alertCtrl.create({
        title: 'رسالة خطأ',
        subTitle: 'اكمل البيانات',
        buttons: ['OK']
      });
      alert2.present();
    }
    else
    {
   let loader = this.loadingCtrl.create({
      content: "Please wait...",
      //duration: 3000,
    });
    loader.present();
  let Df=this.datepipe.transform(this.DateFrom, 'yyyy-MM-dd');
    //var displaytime = this.DateT.toLocaleTimeString();
    let TH=this.DateT.toString().substr(0, this.DateT.toString().indexOf(':')); //.getHours();
    let TM=this.DateT.toString().substr( this.DateT.toString().indexOf(':')+1);

    var headers = new Headers();
    
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
   
    const requestOptions = new RequestOptions({ headers: headers }); 

      let postParams = {
        file:this.imageUploadLists[0],
        ClinicID: this.apiUserProvider.ClinicID,
        DocSerial:this.DocSerial,
        USerial: this.apiUserProvider.USerial,
        Df:Df,
        TH:TH,
        TM:TM,
        HospitalSerial:this.HospitalSerial,
        TypeSerial:this.TypeSerial,
        ResNote:this.ResNote
      }
      
      this.http.post( this.apiUserProvider.MyDomain+'/api/Default/PostMyData',JSON.stringify(postParams), requestOptions)
      .map(res => res.json()).subscribe(data => {
        console.log("received data =>" + JSON.stringify(data));
          this.JobList = data;
         this.Visible1=false;
         this.AddView=false;
         this.imageLists=[];
         this.imageUploadLists=[];
         this.DateT=undefined;//=new Date();
         this.ResNote="";
         this.HospitalSerial="";
         this.TypeSerial="";
         //if(this.JobList.length>0)
         //if(this.imageLists.length>0 ) 
         //this.doImageUpload(this.JobList[this.JobList.length-1].RFileName);

         loader.dismiss();

        },err => {
          alert(this.imageLists[0]);
          alert(this.imageUploadLists[0]);
          console.log(err);
          loader.dismiss();
          const alert2 = this.alertCtrl.create({
            title: 'Error message',
            subTitle: err,
            buttons: ['OK']
          });
          alert2.present();
          });

        }
}



  doImageUpload(FTitle:string) {
    let loader = this.loadingCtrl.create({
      content: "Uploading..."
    });
    loader.present();
    //this.image='assets/imgs/d.png';
    let filename = this.imageLists[0].split('/').pop();
    const fileTransfer: FileTransferObject = this.transfer.create();
    let optionsU: FileUploadOptions = {
      fileKey: "file",
      fileName: filename,
      chunkedMode: false,
      mimeType: "image/jpg",
      params: { 'title': FTitle}
    };
    //this.file.readAsDataURL(this.imageLists[0]);
    fileTransfer.upload(
     this.imageLists[0]
      , this.apiUserProvider.MyDomain+'/api/Default/uploadImage',optionsU).then((res)=>{
    },(err)=>{
      alert( this.imageLists[0]);
      alert(err);
      alert(JSON.stringify(err));      
    });
 
  }

  public openEditModal(item1:any){
    //this.DateT=new Date('1968-11-16T03:20:00' );
    var item = { 'MyItem':item1,'DateT':this.DateT,'TypeList':this.TypeList,
  'HospitalList':this.HospitalList
 // ,'imageLists':this.imageLists 
};
    var modalPage = this.modalController.create(EditModalPage,
      item);
    modalPage.present();
    modalPage.onDidDismiss(data => {
     
      this.JobList = data;
   });
}
}



// WEBPACK FOOTER //
// ./src/pages/nurse/nurse.ts